import { IMyHomeStatusInfoSchema } from '../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';

export enum EStatusLoad {
  init = 'init',
  loading = 'loading',
  succeed = 'succed',
  failed = 'failed',
}

export interface IStatusState {
  statusLoad: EStatusLoad;
  currentStatus?: IMyHomeStatusInfoSchema;
  modalOpen: boolean;
  data: IMyHomeStatusInfoSchema[];
}
